import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';
import { SSOConfigModel } from 'src/app/core/_models/sso/sso.config.model';

const API_USERS_URL = `${environment.apiUrl}/authentications`;
const SSO_URL = `${environment.apiUrl}/configssos`;
let _headers = new HttpHeaders();

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) {
    _headers = _headers.append('apiKey', environment.apiKey);
  }

  // public methods
  login(Username: string, Password: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/login`, { Username, Password });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/forgot-password`, {
      email,
    });
  }

  getSsoConfig(id: string): Observable<SSOConfigModel> {
    const url = `${SSO_URL}/${id}`;
    return this.http.get<SSOConfigModel>(url, {headers: _headers});
  }

  getUserByToken(token): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      ApiKey: environment.apiKey
    });
    return this.http.get<UserModel>(`${API_USERS_URL}/get-user-infor`, {
      headers: httpHeaders,
    });
  }
}
